module.exports = __webpack_public_path__ + "static/assets/pan-card.svg";